import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
// Data Tables

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";

import { NOTIFY, DEFAULTS } from "common/config";
import { LABELS, ERRORS, WARNINGS, SUCCESS, CONFIRMS } from "common/labels";
import { DateFunctions } from "common//datefunctions";

import ExcelGrid from "components/Custom/ExcelGrid";

import { COMMON_JS } from "common/scripts";
import { ApiReports } from "apihandlers//reports";
import { ApiMasters } from "apihandlers//masters/masters";
const ApiReportsHandler = new ApiReports();
const ApiMastersHandler = new ApiMasters();

const BrokerRegister = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState<any>({});
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>(null);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [exportName, setExportName] = useState("");

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "broker",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Broker",
      width: "20%",
    },
    {
      key: "indentNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Indent Number",
      width: "20%",
    },
    {
      key: "vehicleNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Vehicle Number",
      width: "20%",
    },
    {
      key: "driverUsername",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Driver Username",
      width: "20%",
    },
    {
      key: "paymentDate",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Payment Date",
      width: "20%",
    },
    {
      key: "enteredDate",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Entered Date",
      width: "20%",
    },
    {
      key: "paymentAmount",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Payment Amount",
      width: "20%",
      renderSum: true,
    },
    {
      key: "paymentMadeOn",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Payment Date",
      width: "20%",
    },
    {
      key: "chargeType",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Charge Type",
      width: "20%",
    },
    {
      key: "chargesCategoryName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Charges Category Name",
      width: "20%",
    },
    {
      key: "paymntType",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Payment Type",
      width: "20%",
    },
    {
      key: "fuelQuantity",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Fuel Quantity",
      width: "20%",
    },
    {
      key: "remarks",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Remarks",
      width: "20%",
    },
    {
      key: "isPayment",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Is Payment",
      width: "20%",
    },
    {
      key: "activeStatus",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Status",
      width: "20%",
    },
  ];

  useEffect(() => {
    if (loading) {
      getMasterData();
    }
  }, [loading]);

  const getMasterData = () => {
    const args = { minResponse: true };
    ApiMastersHandler.getTransporters(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list: any = [{ id: -1, label: "All" }];
        let recs: any = response.records;
        for (let i = 0; i < recs.length; i++) {
          list.push({
            id: recs[i].id,
            label: recs[i].organizationName,
          });
        }
        setMasters(list);
        setLoading(false);
      }
    });
  };

  const loadChart = () => {
    const id = masterRef.current.selectedValue.id;
    if (!id) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.DATA_IS_EMPTY);
      return;
    }
    const broker = masterRef.current.selectedValue.label;
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    setExportName(
      LABELS.BROKER +
        ":" +
        broker +
        "\n" +
        LABELS.FROM_DATE +
        ":" +
        fromDt +
        "\n" +
        LABELS.TO_DATE +
        ":" +
        toDt
    );
    const args = {
      fromDt,
      toDt,
      // id: -1,
      // vehicleId: -1,
      brokerId: id,
      reportType: "excel",
    };
    let errors = [];
    if (fromDt === "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    // if ($.fn.dataTable.isDataTable("#reportGrid")) {
    //   let table = $("#reportGrid").DataTable();
    //   table.destroy();
    // }
    // if ($("#reportGrid")) {
    //   $("#reportGrid").empty();
    // }
    setChartData(null);
    ApiReportsHandler.getBrokerLedger(args).then((res) => {
      // console.log("getUserLogReport:", args);
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
        }
        setRows(response.rows);

        setChartData(response);

        // setTimeout(() => {
        //   generateReportGrid(response);
        // }, 500);
      }
    });
  };

  const masterRef: any = useRef();

  console.log("elist:", rows);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{LABELS.BROKER_REGISTER_REPORT}</li>
        </ul>
        <h4>{LABELS.BROKER_REGISTER_REPORT}</h4>
      </div>
      {loading ? (
        <div className="flexCenter" style={{ minHeight: 450 }}>
          <Loader />
        </div>
      ) : (
        <div className="hChart">
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 5,
                marginBottom: 10,
                width: "40%",
              }}
            >
              <label>{"Select Broker :"}</label>
              <AutoComplete
                id={"masters"}
                list={masters}
                childRef={masterRef}
                defaultValue={{ id: -1, label: "All" }}
              />
            </div>
            <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 0,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.FROM_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="fromDt"
                  defaultValue={DateFunctions.getDate(
                    "today",
                    "from",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.TO_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="toDt"
                  defaultValue={DateFunctions.getDate(
                    "thismonth",
                    "to",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                }}
              >
                <Btn
                  text={LABELS.LOAD}
                  onClick={loadChart}
                  // loading={!chartData}
                />
              </div>
            </div>
          </div>
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          {rows && (
            <ExcelGrid
              id={"brokerRegisterReport"}
              title={LABELS.BROKER_REGISTER_REPORT}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={exportName}
              // onReload={reloadGrid}
              // onAdd={onAdd}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(BrokerRegister);
